import { FunctionComponent, memo } from 'react'
import { Navigation as SwiperNavigation, Keyboard } from 'swiper'
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'
import Navigation from './Navigation'
import { useNavigation } from './Navigation/hooks'
import { Credit as CreditType } from '@cook-types/cook'
import Credit from '@components/Gallery/Common/SlideImage/Credit'

export { default as classNames } from './classNames'
export { SwiperSlide }
export interface SwiperElementProps extends SwiperProps {
  slides?: any[]
  onNavigationChange?: () => void
  credit?: CreditType
}

const SwiperElement: FunctionComponent<SwiperElementProps> = ({
  slides,
  onNavigationChange,
  credit,
  ...props
}) => {
  const { nextElRef, prevElRef, needsNavigation, navigationProps } =
    useNavigation(props)

  return (
    <Swiper
      {...props}
      navigation={navigationProps}
      modules={[SwiperNavigation, Keyboard]}>
      {slides}
      {needsNavigation && (
        <Navigation
          prevElRef={prevElRef}
          nextElRef={nextElRef}
          onPrevButtonClick={onNavigationChange}
          onNextButtonClick={onNavigationChange}
          {...(typeof navigationProps === 'object' ? navigationProps : {})}
        />
      )}
      {credit && <Credit {...credit} isInMultiGallery={true} />}
    </Swiper>
  )
}

const MemoizedSwiperElement = memo(SwiperElement)

MemoizedSwiperElement.displayName = 'MemoizedSwiperElement'

export default MemoizedSwiperElement
